import CrudCustom from '../../../libs/custom/CrudCustom';

let PengenaanPajakLainnyaService = new CrudCustom('/pengenaan-pajak-lainnyas');
export default PengenaanPajakLainnyaService;
